import React, { useState, useEffect, useId } from "react";
import { FaFacebookF, FaTwitter } from "react-icons/fa";
import { CiMobile2 } from "react-icons/ci";
import logo from "../../assets/Images/logo.png"
import { VscThreeBars } from "react-icons/vsc";
import { IoMdClose } from "react-icons/io";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import allPaths from '../../Config/paths'
import { useDispatch } from 'react-redux'
import { setLanguage } from "../../Redux/actions/languageAction";
import ReactFlagsSelect from 'react-flags-select'
import EnglishFlag from '../../assets/Images/englishFlag.png'
import GermanLanguage from '../../assets/Images/germanLangugae.png'
import ArabicLanguage from '../../assets/Images/arabicLanguage.jpg'
import { doctorsMenuItems, menuItems } from "../../utils/constants";



const Header = (props) => {
    const { user } = props
    console.log('=user', user)
    const [isHeaderFixed, setIsHeaderFixed] = useState(false);
    const [toggle, setToggle] = useState(false)
    const [selected, setSelected] = useState('GB');
    const history = useHistory()
    const dispatch = useDispatch()
    const { selectedLanguage, language } = props
    const isELSelect = language?.language === 'english'
    const isAlSelect = language?.language === 'arabic'
    let menus = user?._id && user?.userType === 'clanic' ? menuItems :user?._id && user?.userType !== 'clanic' ? doctorsMenuItems:menuItems?.filter((v) => v?.forclanic !== true) 
    
    const changeLanguage = (language) => {
        dispatch(setLanguage(language));
    }

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > window.innerHeight) {
                setIsHeaderFixed(true);
            } else {
                setIsHeaderFixed(false);
            }
        };
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);
    const toggled = () => {
        setToggle(!toggle)
    }
    const handleNavigation = (path) => {
        history.push(path);
    };
    return (
        <div>
            <div className="header-1">
                <div className="header-1-inner-div">
                    <div className="header-text-div">
                        <p className="header-text">
                            <CiMobile2 className="mobile-icon" />{selectedLanguage?.txt_call_for_free_consultation}<a className="header-text-link" href="">Hurghada: +20 114 551 4733</a> // <a className="header-text-link" href="">Cairo: +20 100 664 4922</a>
                        </p>
                    </div>
                    <div className="header-social-icons-div">
                        <button className="social-icons-button"><FaFacebookF className="social-icons" /></button>
                        <button className="social-icons-button"><FaTwitter className="social-icons" /></button>
                        <span onClick={() => changeLanguage('english')} >
                            <img src={EnglishFlag} className="LanguageChange" />
                        </span>
                        <span onClick={() => changeLanguage('arabic')}>
                            <img src={ArabicLanguage} className="arabicLanguage" />
                        </span>
                        <span onClick={() => changeLanguage('german')}>
                            <img src={GermanLanguage} className="LanguageChange" />
                        </span>
                    </div>
                </div>
            </div>
            <div className={isHeaderFixed ? "header-2 header-fixed" : "header-2"}>
                <div className="header-2-inner-div">
                    <div className="header-logo-div"><img onClick={() => handleNavigation(allPaths?.HOME)} src={logo} alt="" />
                        {toggle ? <nav className="navbar mobile-navbar">
                            <ul>
                                {
                                    menus?.map((v, i) => {
                                        return (
                                            <li onClick={() => handleNavigation(v?.menuRoute)}><a href="">
                                                {isELSelect ? v?.menuName : (isAlSelect ? v?.menuALName : v?.menuGLName)}
                                            </a></li>
                                        )
                                    })
                                }
                            </ul>
                        </nav>
                            :
                            null
                        }
                    </div>
                    <div>
                        <nav className="navbar">
                            <ul>
                                {
                                    menus?.map((v, i) => {
                                        return (
                                            <li key={i} onClick={() => handleNavigation(v?.menuRoute)}>
                                                <a className="a" href="">
                                                    {isELSelect ? v?.menuName : (isAlSelect ? v?.menuALName : v?.menuGLName)}
                                                </a>
                                            </li>
                                        )
                                    })
                                }
                            </ul>
                        </nav>
                    </div>
                    <div className="toggle-btn-div" onClick={toggled}>
                        {!toggle ?
                            <VscThreeBars />
                            :
                            <IoMdClose />
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Header